var _path, _path2, _circle, _circle2, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPairSelfCareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    strokeWidth: 9.5,
    stroke: "#ffffff",
    fill: "#ffffff",
    style: {
      margin: 5
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 220",
    strokeWidth: 9.5,
    stroke: "currentcolor",
    fill: "currentcolor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 184.314482547739 176.913060635886 A 100 100 0 0 0 43.0869393641142 35.6855174522606",
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 35.6855174522606 43.0869393641142 A 100 100 0 0 0 176.913060635886 184.314482547739",
    fill: "none",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 69,
    r: 9.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 151,
    r: 9.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 60.5025253169417,
    y1: 60.5025253169417,
    x2: 159.497474683058,
    y2: 159.497474683058,
    fill: "none",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 60.5025253169417,
    y1: 99.0012626584708,
    x2: 120.998737341529,
    y2: 159.497474683058,
    fill: "none",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 99.0012626584708,
    y1: 60.5025253169417,
    x2: 159.497474683058,
    y2: 120.998737341529,
    fill: "none",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPairSelfCareIcon);
export default __webpack_public_path__ + "static/media/PairSelfCareIcon.5b5b09cdc2d3d405f82755327aa6f79d.svg";
export { ForwardRef as ReactComponent };